<template>
  <div>
    <div class="form-group col-sm-6">
      <input
        class="form-control"
        type="text"
        v-model="query"
        @blur="reset"
        :placeholder="placeholder"
      />
    </div>

    <transition-group name="fade" tag="ul" class="Results">
      <li v-for="item in items" :key="item.id">
        <span>{{ item.name || item.title }}</span>
      </li>
    </transition-group>

    <p v-show="noResults">No results</p>
  </div>
</template>

<script>
import ToastrType from "../toastr-types.interface";

export default {
  name: "typeahead",

  props: {
    model: {
      type: String,
      required: true,
    },

    modelField: {
      type: String,
      default: false,
    },

    minLength: {
      type: Number,
      default: 2,
    },

    placeholder: {
      type: String,
      default: "Begin typing...",
    },
  },

  data() {
    return {
      items: [],
      query: "",
      noResults: false,
      currentRequest: null,
    };
  },

  watch: {
    query: function (value) {
      this.search();
    },
  },

  methods: {
    search() {
      if (!this.query || this.query.length < this.minLength) {
        return;
      }

      // Cancel the previous request if it exists
      if (this.currentRequest && this.currentRequest.readyState !== 4) {
        this.currentRequest.abort();
      }

      let ctx = this;

      $.ajaxSetup({
        headers: {
          "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
        cache: false,
      });

      ctx.items = [];

      this.currentRequest = $.ajax({
        method: "GET",
        url: `/api/typeaheadsearch/${this.model}/${this.query}/${this.modelField ? this.modelField : ""}?timestamp=${Date.now()}`,
      })
        .done(function (source) {
          ctx.items = source;

          if (!source.length) {
            ctx.noResults = true;
          }
        })
        .fail(function (responseData) {
          // Don't show error if the request was aborted
          if (responseData.statusText !== "abort") {
            playerService.toast("Error. Could not search.", ToastrType.Error);
          }
        });
    },

    reset() {
      // Cancel any ongoing request when resetting
      if (this.currentRequest && this.currentRequest.readyState !== 4) {
        this.currentRequest.abort();
      }

      this.query = "";
      this.items = [];
      this.noResults = false;
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
